module.exports = __webpack_public_path__ + "static/media/camera-old.1945250b.svg";